import styled from "styled-components/macro";
import { CENTER_LABEL_HEIGHT } from "../../TrendChartStyles";

export const TrendChartCenterMetricStyles = styled.div<{
  $numRowsVisible: number;
}>`
  min-height: ${CENTER_LABEL_HEIGHT}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  line-height: 14px;
  transform: scale(${props => (props.$numRowsVisible === 3 ? 0.9 : 1)});
  .noPercentIndicator {
    margin-bottom: -2px;
  }
  .metricPercent {
    margin-bottom: ${props => (props.$numRowsVisible === 3 ? -2 : 0)}px;
    .percent {
      font-size: 0.7em;
    }
  }
  .MuiDivider-root {
    margin: ${props =>
      props.$numRowsVisible === 3 ? "2px auto 2px" : "1px auto 4px"};
    width: 16px;
    background-color: hsl(0, 0%, 75%);
  }
`;
